import { ServiceTokens } from "$src/domain/ServiceTokens";
import { CreateCustomerData } from "$src/domain/customers/CreateCustomerData";
import { CustomerIdentifier } from "$src/domain/customers/CustomerIdentifier";
import * as ICustomerRepository from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class CreateCustomer {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository.ICustomerRepository) {}

    async execute(groupStoreId: number, data: CreateCustomerData): Promise<CustomerIdentifier> {

        var identifier = await this.customerRepository.createCustomer(groupStoreId, data);

        return identifier;
    }
}

export const CreateCustomerToken = Symbol('CreateCustomerToken');